<div class="workSpace" style="background-color: transparent;">
  <div class="w3-row">
    <div class="custom-select-container">
      <div class="select-box" (click)="toggleDropdown()">
        @if (selected) {
          <span>{{ selected.nombre }}</span>
        }@else {
          <span>{{ placeholder | translate }}</span>
        }
      </div>
      @if (dropdownOpen) {
        <ul class="options">
          @for (p of options; track $index) {
            <li (click)="selectOption(p)">{{ p[displayKey] }}</li>
          }
        </ul>
      }
    </div>
  </div>
  
</div>